import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-year-to-date',
  templateUrl: './year-to-date.component.html',
  styleUrls: ['./year-to-date.component.scss', '../../../dashboard.scss'],
  standalone: false
})
export class YearToDateComponent {
  @Input() dashboardData: any

  yearToDateSalesTop: any;
  yearToDateSalesBottom: any;
  yearToDateLabourPerTop: any;
  yearToDateLabourPerBottom: any;
  yearToDateOnlineSalesTop: any;
  yearToDateOnlineSalesBottom: any;
  yearToDateOnlineCustomerOrdersTop: any;
  yearToDateOnlineCustomerOrdersBottom: any;
  yearToDateTargetTop: any;
  yearToDateTargetBottom: any;
  yearToDateLabourHoursTop: any;
  yearToDateLabourHoursBottom: any;
  yearToDateCustomerOrdersTop: any;
  yearToDateCustomerOrdersBottom: any;
  yearToDateLabourCostTop: any;
  yearToDateLabourCostBottom: any;
  yearToDateItemsSoldTop: any;
  yearToDateItemsSoldBottom: any;
  yearToDateSalesByLabourHourTop: any;
  yearToDateSalesByLabourHourBottom: any;
  yearToDateSalesValueByItemTop: any;
  yearToDateSalesValueByItemBottom: any;
  yearToDateAverageOrderTop: any;
  yearToDateAverageOrderBottom: any;

  // New: Year-to-date Drive-Thru (DT) Sales
  yearToDateDtSalesTop: any;
  yearToDateDtSalesBottom: any;

  // New: Year-to-date Drive-Thru (DT) Sales Count
  yearToDateDtSalesCountTop: any;
  yearToDateDtSalesCountBottom: any;


  GST_VALUE: any;
  targetImg: string = "<img class='target-arrow' src='assets/images/target_img.png' style='height:16px;vertical-align:middle;'/>";
  shopType: any;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dashboardData']) {
      this.shopType = this.dashboardData?.sales_all_shops[0].shop_type;
      const dash_board_data = this.dashboardData?.dashboard_data_v3?.[0];
      this.GST_VALUE = dash_board_data?.gst_value ?? 1;


      // -------YEAR TO DATE - SALES-------
      let ytd_sales = this.fnCheckNull(dash_board_data?.ytd_sales) - this.fnCheckNull(dash_board_data?.sales_today);
      ytd_sales = this.setDecimalPoints(ytd_sales, 0);
      this.yearToDateSalesTop = ytd_sales;
      let last_year_ytd_sales = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_sales), 0);
      let ytd_sales_diff = ytd_sales - last_year_ytd_sales;
      let ytd_sales_per = 0;
      if (last_year_ytd_sales !== 0) {
        ytd_sales_per = this.setDecimalPoints((ytd_sales_diff / last_year_ytd_sales) * 100, 1);
      }
      let label_1_2_sales =
        this.setFontColorWithUpDownArrow(ytd_sales_per, '%', false, 1) + 'LY' + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_sales_diff, '$', false, 0) + 'LY';
      this.yearToDateSalesBottom = label_1_2_sales;

      // -------YEAR TO DATE - DT SALES (Drive-Thru)-------
      let ytd_dt_sales = this.fnCheckNull(dash_board_data?.ytd_dt_sales) - this.fnCheckNull(dash_board_data?.today_dt_sales);
      ytd_dt_sales = this.setDecimalPoints(ytd_dt_sales, 0);
      this.yearToDateDtSalesTop = ytd_dt_sales;

      let last_year_ytd_dt_sales = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_dt_sales), 0);
      let label_1_2_dt_sales = "-&nbsp-";
      if (last_year_ytd_dt_sales > 0) {
        let ytd_dt_sales_diff = ytd_dt_sales - last_year_ytd_dt_sales;
        let ytd_dt_sales_per = 0;
        if (last_year_ytd_dt_sales !== 0) {
          ytd_dt_sales_per = this.setDecimalPoints((ytd_dt_sales_diff / last_year_ytd_dt_sales) * 100, 1);
        }
        // Optionally: ytd_online_sales_lyt if needed
        label_1_2_dt_sales = this.setFontColorWithUpDownArrow(ytd_dt_sales_per, '%', false, 1) + 'LY' + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_dt_sales_diff, '$', false, 0) + 'LY';
      }
      this.yearToDateDtSalesBottom = label_1_2_dt_sales;

      // -------YEAR TO DATE - DT SALES COUNT (Drive-Thru)-------
      let ytd_dt_sales_count = this.fnCheckNull(dash_board_data?.ytd_dt_sales_count) - this.fnCheckNull(dash_board_data?.today_dt_sales_count);
      ytd_dt_sales_count = this.setDecimalPoints(ytd_dt_sales_count, 0);
      this.yearToDateDtSalesCountTop = ytd_dt_sales_count;
      let label_1_2_dt_sales_count = "-&nbsp-";
      let last_year_ytd_dt_sales_count = this.fnCheckNull(dash_board_data?.last_year_ytd_dt_sales_count);
      if (last_year_ytd_dt_sales_count > 0) {
        let ytd_dt_sales_diff = ytd_dt_sales_count - last_year_ytd_dt_sales_count;
        ytd_dt_sales_diff = this.setDecimalPoints(ytd_dt_sales_diff);
        let ytd_dt_sales_per = 0;
        if (last_year_ytd_dt_sales_count !== 0) {
          ytd_dt_sales_per = this.setDecimalPoints((ytd_dt_sales_diff / last_year_ytd_dt_sales_count) * 100, 1);
        }
        label_1_2_dt_sales_count = this.setFontColorWithUpDownArrow(ytd_dt_sales_per, '%', false) + 'LY' + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_dt_sales_diff, '$', false, 0) + 'LY';
      }
      this.yearToDateDtSalesCountBottom = label_1_2_dt_sales_count;

      // -------YEAR TO DATE - CUSTOMER ORDERS-------
      let ytd_no_of_cust_orders = this.fnCheckNull(dash_board_data?.ytd_no_of_cust_orders) - this.fnCheckNull(dash_board_data?.today_no_of_cust_orders);
      ytd_no_of_cust_orders = this.setDecimalPoints(ytd_no_of_cust_orders, 0);
      this.yearToDateCustomerOrdersTop = ytd_no_of_cust_orders;

      let last_year_ytd_cus_orders = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_cus_orders));
      let ytd_cust_orders_diff = ytd_no_of_cust_orders - last_year_ytd_cus_orders;
      let ytd_cust_orders_per = 0;
      if (last_year_ytd_cus_orders !== 0) {
        ytd_cust_orders_per = this.setDecimalPoints((ytd_cust_orders_diff / last_year_ytd_cus_orders) * 100, 1);
      }
      let ytd_no_of_cust_orders_lyt = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_no_of_cust_orders_lyt));
      let label_1_2_cust_orders = this.setFontColorWithUpDownArrow(ytd_cust_orders_per, '%', false,1) + 'LY' + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_cust_orders_diff, '', false, 0) + 'LY';
      this.yearToDateCustomerOrdersBottom = label_1_2_cust_orders;

      // -------YEAR TO DATE - LABOUR COST-------
      let ytd_labour_cost = this.fnCheckNull(dash_board_data?.ytd_labour_cost) - this.fnCheckNull(dash_board_data?.today_labour_cost);
      ytd_labour_cost = this.setDecimalPoints(ytd_labour_cost);
      this.yearToDateLabourCostTop = ytd_labour_cost;
      let label_1_2_labour_cost = "- &nbsp -";
      let last_year_ytd_labour_cost = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_labour_cost));
      if (last_year_ytd_labour_cost > 0) {
        let ytd_labour_cost_diff = ytd_labour_cost - last_year_ytd_labour_cost;
        ytd_labour_cost_diff = this.setDecimalPoints(ytd_labour_cost_diff, 0);
        let ytd_labour_cost_per = 0;
        if (last_year_ytd_labour_cost !== 0) {
          ytd_labour_cost_per = this.setDecimalPoints((ytd_labour_cost_diff / last_year_ytd_labour_cost) * 100, 1);
        }
        let ytd_labour_cost_lyt = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_labour_cost_lyt));
        label_1_2_labour_cost = this.setFontColorWithUpDownArrow(ytd_labour_cost_per, '%', true,1) + 'LY' + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_labour_cost_diff, '$', true, 0) + 'LY';
      }
      this.yearToDateLabourCostBottom = label_1_2_labour_cost;
      // -------YEAR TO DATE - LABOUR %-------
      let this_year_sales_wo_gst = this.setDecimalPoints((this.fnCheckNull(dash_board_data?.ytd_sales) - this.fnCheckNull(dash_board_data?.sales_today)) / this.GST_VALUE);
      let ytd_labour_per = this.setDecimalPoints(((this.fnCheckNull(dash_board_data?.ytd_labour_cost) - this.fnCheckNull(dash_board_data?.today_labour_cost)) / this_year_sales_wo_gst) * 100);
      this.yearToDateLabourPerTop = ytd_labour_per + '%';
      let last_year_ytd_labour_per = this.setDecimalPoints((this.fnCheckNull(dash_board_data?.last_year_ytd_labour_cost) / (this.fnCheckNull(dash_board_data?.last_year_ytd_sales) / this.GST_VALUE)) * 100);
      let ytd_labour_per_diff = this.setDecimalPoints(ytd_labour_per - last_year_ytd_labour_per);
      let this_year_roster_sales_wo_gst = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_target) / this.GST_VALUE);
      let this_year_ytd_roster_labor_cost = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_roster_labor_cost) - this.fnCheckNull(dash_board_data?.today_roster_labor_cost), 0);
      let this_year_ytd_roster_labour_per = this.setDecimalPoints((this_year_ytd_roster_labor_cost / this_year_roster_sales_wo_gst) * 100);
      let ytd_roster_labour_per_diff = this.setDecimalPoints(ytd_labour_per - this_year_ytd_roster_labour_per);
      let label_1_2_labour =
        this.setFontColorWithUpDownArrow(ytd_roster_labour_per_diff, '%', true,1) + this.targetImg + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_labour_per_diff, '%', true,1) + 'LY ';
      this.yearToDateLabourPerBottom = label_1_2_labour;
      // -------YEAR TO DATE - ONLINE SALES-------
      let ytd_online_sales = this.fnCheckNull(dash_board_data?.ytd_online_sales) - this.fnCheckNull(dash_board_data?.today_online_sales);
      ytd_online_sales = this.setDecimalPoints(ytd_online_sales, 0);
      this.yearToDateOnlineSalesTop = ytd_online_sales;
      let last_year_ytd_online_sales = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_online_sales));
      let label_1_2_online = "- &nbsp -";
      if (last_year_ytd_online_sales > 0) {
        let ytd_online_sales_diff = ytd_online_sales - last_year_ytd_online_sales;
        let ytd_online_sales_per = 0;
        if (last_year_ytd_online_sales !== 0) {
          ytd_online_sales_per = this.setDecimalPoints((ytd_online_sales_diff / last_year_ytd_online_sales) * 100, 1);
        }
        label_1_2_online = this.setFontColorWithUpDownArrow(ytd_online_sales_per, '%', false,1) + 'LY' + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_online_sales_diff, '$', false, 0) + 'LY';
      }
      this.yearToDateOnlineSalesBottom = label_1_2_online;

      // -------YEAR TO DATE - ONLINE CUSTOMER ORDERS-------
      let ytd_online_sales_count = this.fnCheckNull(dash_board_data?.ytd_online_sales_count) - this.fnCheckNull(dash_board_data?.today_online_sales_count);
      ytd_online_sales_count = this.setDecimalPoints(ytd_online_sales_count, 0);
      this.yearToDateOnlineCustomerOrdersTop = ytd_online_sales_count;
      let last_year_ytd_online_sales_count = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_online_sales_count), 0);
      let label_1_2_online_orders = "- &nbsp -";
      if (last_year_ytd_online_sales_count > 0) {
        let ytd_online_sales_diff = ytd_online_sales_count - last_year_ytd_online_sales_count;
        ytd_online_sales_diff = this.setDecimalPoints(ytd_online_sales_diff);
        let ytd_online_sales_per = 0;
        if (last_year_ytd_online_sales_count !== 0) {
          ytd_online_sales_per = this.setDecimalPoints((ytd_online_sales_diff / last_year_ytd_online_sales_count) * 100, 1);
        }
        label_1_2_online_orders = this.setFontColorWithUpDownArrow(ytd_online_sales_per, '%', false,1) + 'LY' + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_online_sales_diff, '$', false, 0) + 'LY';
      }
      this.yearToDateOnlineCustomerOrdersBottom = label_1_2_online_orders;

      // -------YEAR TO DATE - TARGET-------
      let ytd_target = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_target));
      this.yearToDateTargetTop = ytd_target;
      let ytd_target_vari = this.setDecimalPoints(this.fnCheckNull(ytd_sales - ytd_target));
      let ytd_target_perc = 0;
      if (ytd_target !== 0) {
        ytd_target_perc = this.setDecimalPoints(this.fnCheckNull((ytd_target_vari / ytd_target) * 100));
      }
      let label_1_2_target =
        this.setFontColorWithUpDownArrow(ytd_target_perc, '%', false,1) + this.targetImg + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_target_vari, '$', false, 0) + this.targetImg + ' &nbsp ';
      this.yearToDateTargetBottom = label_1_2_target;

      // -------YEAR TO DATE - LABOUR HOURS-------
      let ytd_labour_hours = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_labour_hours) - this.fnCheckNull(dash_board_data?.today_labour_hours), 0);
      this.yearToDateLabourHoursTop = ytd_labour_hours;
      let last_year_ytd_labour_hours = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_labour_hours));
      let label_1_2_labour_hours = "- &nbsp -";
      if (last_year_ytd_labour_hours > 0) {
        let ytd_labour_hour_diff = this.setDecimalPoints(ytd_labour_hours - last_year_ytd_labour_hours);
        let ytd_labour_hour_per = 0;
        if (last_year_ytd_labour_hours !== 0) {
          ytd_labour_hour_per = this.setDecimalPoints((ytd_labour_hour_diff / last_year_ytd_labour_hours) * 100, 1);
        }
        label_1_2_labour_hours = this.setFontColorWithUpDownArrow(ytd_labour_hour_per, '%', true, 1) + 'LY' + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_labour_hour_diff, '', true, 0) + 'LY';
      }
      this.yearToDateLabourHoursBottom = label_1_2_labour_hours;

      // -------YEAR TO DATE - ITEMS SOLD-------
      let ytd_items_sold = this.fnCheckNull(dash_board_data?.ytd_items_sold) - this.fnCheckNull(dash_board_data?.today_items_sold);
      ytd_items_sold = this.setDecimalPoints(ytd_items_sold, 0);
      this.yearToDateItemsSoldTop = ytd_items_sold;
      let last_year_ytd_items_sold = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_items_sold));
      let ytd_items_sold_diff = ytd_items_sold - last_year_ytd_items_sold;
      ytd_items_sold_diff = this.setDecimalPoints(ytd_items_sold_diff);
      let ytd_items_sold_per = 0;
      if (last_year_ytd_items_sold !== 0) {
        ytd_items_sold_per = this.setDecimalPoints((ytd_items_sold_diff / last_year_ytd_items_sold) * 100, 1);
      }
      let ytd_items_sold_lyt = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.ytd_items_sold_lyt));
      let label_1_2_items_sold = this.setFontColorWithUpDownArrow(ytd_items_sold_per, '%', false,1) + 'LY' + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_items_sold_diff, '', false, 0) + 'LY';
      this.yearToDateItemsSoldBottom = label_1_2_items_sold;

      // -------YEAR TO DATE - SALES / LABOUR HOUR-------
      let ytd_sales_by_labour_hour = 0;
      if (this.yearToDateLabourHoursTop && this.yearToDateLabourHoursTop !== 0) {
        ytd_sales_by_labour_hour = this.yearToDateSalesTop / this.yearToDateLabourHoursTop;
      }
      ytd_sales_by_labour_hour = this.setDecimalPoints(ytd_sales_by_labour_hour, 2);
      this.yearToDateSalesByLabourHourTop = ytd_sales_by_labour_hour;
      // console.log(dash_board_data)
      let last_year_ytd_sales_hour = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_sales), 0);
      let last_year_ytd_labour_hour = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_labour_hours));
      let last_year_ytd_sales_by_labour_hour = 0;
      if (last_year_ytd_labour_hour !== 0) {
        last_year_ytd_sales_by_labour_hour = last_year_ytd_sales_hour / last_year_ytd_labour_hour;
      }
      let ytd_sales_by_labour_hour_ly_diff = ytd_sales_by_labour_hour - last_year_ytd_sales_by_labour_hour;
      ytd_sales_by_labour_hour_ly_diff = this.setDecimalPoints(ytd_sales_by_labour_hour_ly_diff, 0);
      let ytd_sales_by_labour_hour_per = 0;
      if (last_year_ytd_sales_by_labour_hour !== 0) {
        ytd_sales_by_labour_hour_per = this.setDecimalPoints((ytd_sales_by_labour_hour_ly_diff / last_year_ytd_sales_by_labour_hour) * 100, 1);
      }
      let label_1_2_sales_by_labour_hour = this.setFontColorWithUpDownArrow(ytd_sales_by_labour_hour_per, "%", false,1) + 'LY' + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_sales_by_labour_hour_ly_diff, '$', false, 0) + 'LY';
      this.yearToDateSalesByLabourHourBottom = label_1_2_sales_by_labour_hour;

      // -------YEAR TO DATE - SALES VALUE / ITEM-------
      let ytd_sales_value_by_item = 0;
      if (ytd_items_sold && ytd_items_sold !== 0) {
        ytd_sales_value_by_item = ytd_sales / ytd_items_sold;
      }
      ytd_sales_value_by_item = this.setDecimalPoints(ytd_sales_value_by_item, 1);
      this.yearToDateSalesValueByItemTop = ytd_sales_value_by_item;
      let last_year_ytd_sale_items_sold = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_ytd_items_sold));
      let last_year_ytd_sales_value_by_item = 0;
      if (last_year_ytd_items_sold && last_year_ytd_items_sold !== 0) {
        last_year_ytd_sales_value_by_item = last_year_ytd_sales / last_year_ytd_items_sold;
      }
      last_year_ytd_sales_value_by_item = this.setDecimalPoints(last_year_ytd_sales_value_by_item, 1);
      let ytd_sales_value_by_item_diff = ytd_sales_value_by_item - last_year_ytd_sales_value_by_item;
      ytd_sales_value_by_item_diff = this.setDecimalPoints(ytd_sales_value_by_item_diff, 0);
      let ytd_sales_value_by_item_per = 0;
      if (last_year_ytd_sales_value_by_item !== 0) {
        ytd_sales_value_by_item_per = this.setDecimalPoints((ytd_sales_value_by_item_diff / last_year_ytd_sales_value_by_item) * 100, 1);
      }
      let label_1_2_sales_value_by_item = this.setFontColorWithUpDownArrow(ytd_sales_value_by_item_per, '%', false,1) + 'LY' + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_sales_value_by_item_diff, '$', false, 2) + 'LY';
      this.yearToDateSalesValueByItemBottom = label_1_2_sales_value_by_item;

      // -------YEAR TO DATE - AVERAGE ORDER $-------
      let yearToDateAverageOrder = 0;
      if (ytd_no_of_cust_orders && ytd_no_of_cust_orders !== 0) {
        yearToDateAverageOrder = ytd_sales / ytd_no_of_cust_orders;
      }
      yearToDateAverageOrder = this.setDecimalPoints(yearToDateAverageOrder, 2);
      this.yearToDateAverageOrderTop = yearToDateAverageOrder;
      let last_year_ytd_average_order = 0;
      if (last_year_ytd_cus_orders && last_year_ytd_cus_orders !== 0) {
        last_year_ytd_average_order = last_year_ytd_sales / last_year_ytd_cus_orders;
      }
      last_year_ytd_average_order = this.setDecimalPoints(last_year_ytd_average_order, 2);
      let ytd_average_order_diff = yearToDateAverageOrder - last_year_ytd_average_order;
      ytd_average_order_diff = this.setDecimalPoints(ytd_average_order_diff, 0);
      let ytd_average_order_per = 0;
      if (last_year_ytd_average_order !== 0) {
        ytd_average_order_per = this.setDecimalPoints((ytd_average_order_diff / last_year_ytd_average_order) * 100, 1);
      }
      let label_1_2_average_order = this.setFontColorWithUpDownArrow(ytd_average_order_per, "%", false,1) + 'LY' + ' &nbsp ' + this.setFontColorWithUpDownArrow(ytd_average_order_diff, '$', false, 0) + 'LY';
      this.yearToDateAverageOrderBottom = label_1_2_average_order;
    }

  }
  ngOnInit() {

  }
  setFontColorWithUpDownArrow(
    numberForSet: number,
    symbol: string = '',
    reverse: boolean = false,
    decimal: number = 1
  ): string {
    if (isNaN(numberForSet)) {
            return '-- ';
        }
    let baseNumber: string | number = numberForSet;
    let numberWithSymbol: string;

    if (symbol === '%') {
      baseNumber = Number(numberForSet).toLocaleString('en-US', {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal,
      });
      numberWithSymbol = baseNumber + symbol;
    } else if (symbol === '$') {
      baseNumber = Number(numberForSet).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: decimal,
      });
      numberWithSymbol = baseNumber as string;
    } else {
      numberWithSymbol = Number(numberForSet).toLocaleString('en-US', {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: decimal,
      });
    }

    let arrow = '';
    if (Math.sign(numberForSet) === 1) {
      arrow = '▲';
    } else if (Math.sign(numberForSet) === -1) {
      arrow = '▼';
    }

    const compareValue = reverse ? numberForSet * -1 : numberForSet;

    if (Math.sign(compareValue) === 0) {
      return numberWithSymbol;
    } else if (Math.sign(compareValue) === 1) {
      let colorWithNumber = `<span class='cgreen'>${numberWithSymbol}${arrow}</span>`;
      colorWithNumber = colorWithNumber.replace('-', '');
      return colorWithNumber;
    } else if (Math.sign(compareValue) === -1) {
      let colorWithNumber = `<span class='cred'>${numberWithSymbol}${arrow}</span>`;
      colorWithNumber = colorWithNumber.replace('-', '');
      return colorWithNumber;
    } else {
      return numberWithSymbol;
    }
  }

  setDecimalPoints(value: number, decimal: number = 1): number {
    return Number(Number(value).toFixed(decimal));
  }
  fnCheckNull(a: any): number {
    return a == null ? 0 : a;
  }
}
